module.exports = __webpack_public_path__ + "static/img/wangbaguanli.97afed12.png";